import React, { useState, useEffect, useRef } from "react";
import "./style.scss";
import { connect, useDispatch, useSelector } from "react-redux";
import ItemMenu from "../ItemMenu";
import ChangePass from './ChangePass';


import Profile from "./Profile";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const SideBar = (props) => {
  const menus = useRef(null);
  const [active, setActive] = useState(-1);
  const isFirstRender = useRef(true);

  const [state, _setState] = useState(() => ({
    show: false,
    menus: [...props.menus],
    active: -1,
  }));

  const setState = (_state) => {
    _setState((state) => ({
      ...state,
      ...(_state || {}),
    }));
  };

  useEffect(() => {
  }, [active])

  useEffect(() => {
    _setState({ ...state, menus: [...props.menus] })
  }, [props.menus])

  useEffect(() => {
  });

  useEffect(() => {
  }, [props.userApp]);

  const toggle = (item) => {
    item.open = !item.open;
    menus.current = [...state.menus];
    setState({ menus: menus.current });
  };

  const handleSetActive = (index) => () => {
    //  in the first render check match url to open menu
    if (isFirstRender.current) {
      let matchItem = state.menus[index];
      toggle(matchItem)
      isFirstRender.current = false;
    }
    setActive(index);
  };

  const passRef = useRef();

  const handleChangePass = () => {
    passRef.current.onOpen()
  }


  return (
    <aside className="page-sidebar list-filter-active">
      <ChangePass ref={passRef} />
      <a
        href="#"
        className="toggle-sidebar-btn btn js-waves-off"
        data-action="toggle"
        data-class="nav-function-hidden"
        title="Toggle Navigation"
      >
        <LeftOutlined />
      </a>
      <div className="page-logo">
        <a href="#" className="link-logo">
          <svg width="145" height="40" viewBox="0 0 145 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.57564 33.5977H1.79432V16.2325H5.57564V33.5977ZM23.6995 19.3515H14.7761C13.7886 19.3515 13.0781 19.5201 12.6445 19.8573C12.203 20.2185 11.9822 20.8006 11.9822 21.6034C11.9822 22.2136 12.1709 22.6832 12.5482 23.0124C12.9576 23.3255 13.5277 23.482 14.2582 23.482H19.0391C21.0301 23.482 22.4431 23.8594 23.278 24.614C24.1049 25.3928 24.5184 26.6612 24.5184 28.4194C24.5184 30.1937 24.0407 31.4983 23.0853 32.3332C22.1139 33.1762 20.5925 33.5977 18.5212 33.5977H8.89935V30.5148H17.9553C18.9909 30.5148 19.7215 30.3582 20.147 30.0451C20.5564 29.7481 20.7611 29.2463 20.7611 28.5398C20.7611 27.8494 20.5644 27.3316 20.1711 26.9864C19.7777 26.6893 19.1194 26.5408 18.1961 26.5408H13.9331C11.9581 26.5408 10.513 26.1394 9.59781 25.3366C8.66653 24.5257 8.20089 23.2653 8.20089 21.5552C8.20089 19.7328 8.69062 18.3841 9.67007 17.509C10.6335 16.658 12.1548 16.2325 14.2341 16.2325H23.6995V19.3515ZM26.12 24.7465C26.12 21.768 26.8305 19.5482 28.2515 18.087C29.6484 16.6339 31.8 15.9073 34.7063 15.9073C37.6205 15.9073 39.7761 16.65 41.173 18.1352C42.57 19.6124 43.2684 21.8724 43.2684 24.9151C43.2684 27.9738 42.57 30.2418 41.173 31.719C39.7601 33.2123 37.6045 33.9589 34.7063 33.9589C31.7519 33.9589 29.5842 33.2123 28.2034 31.719C26.8145 30.2418 26.12 27.9176 26.12 24.7465ZM34.7063 18.8698C33.1648 18.8698 32.0047 19.3635 31.226 20.351C30.4553 21.3385 30.0699 22.8117 30.0699 24.7706C30.0699 26.89 30.4392 28.4515 31.1778 29.4551C31.9245 30.4586 33.1006 30.9604 34.7063 30.9604C36.2878 30.9604 37.456 30.4586 38.2106 29.4551C38.9653 28.4676 39.3426 26.9543 39.3426 24.9151C39.3426 22.8759 38.9653 21.3545 38.2106 20.351C37.456 19.3635 36.2878 18.8698 34.7063 18.8698ZM45.6047 25.6256C45.6047 23.3777 45.7371 21.7439 46.0021 20.7243C46.2509 19.7047 46.7126 18.8658 47.3869 18.2074C48.0453 17.5491 48.9244 17.0554 50.0242 16.7262C51.108 16.3971 52.4488 16.2325 54.0464 16.2325H59.5498V19.2672H53.7453C52.22 19.2672 51.088 19.5963 50.3494 20.2547C49.5867 20.929 49.2053 22.0088 49.2053 23.4941H59.5498V26.4926H49.2053V33.5977H45.6047V25.6256ZM65.571 16.2325V23.2893H72.2064V16.2325H75.8071V33.5977H72.2064V26.3481H65.571V33.5977H61.9703V16.2325H65.571ZM86.4285 19.219C84.9352 19.219 83.8594 19.6967 83.2011 20.6521C82.5428 21.5994 82.2136 23.1769 82.2136 25.3847C82.2136 27.2714 82.5267 28.6081 83.1529 29.3949C83.7791 30.1736 84.871 30.563 86.4285 30.563H92.3774V33.5977H86.2599C84.879 33.5977 83.8193 33.4812 83.0807 33.2484C82.326 33.0317 81.6035 32.6383 80.913 32.0683C80.038 31.3778 79.3756 30.4546 78.926 29.2985C78.4845 28.1665 78.2637 26.8097 78.2637 25.2282C78.2637 22.1774 78.922 19.9094 80.2387 18.4242C81.5553 16.9631 83.5945 16.2325 86.3562 16.2325H92.3774V19.219H86.4285ZM101.722 19.7127L99.2296 26.3722H104.336L101.722 19.7127ZM99.9401 16.2325H103.794L111.115 33.5977H107.093L105.516 29.4791H98.0494L96.52 33.5977H92.6905L99.9401 16.2325ZM120.364 19.3515H115.932V23.7108H120.376C121.556 23.7108 122.387 23.5342 122.869 23.181C123.343 22.8598 123.579 22.3019 123.579 21.5071C123.579 20.7363 123.347 20.1784 122.881 19.8332C122.407 19.512 121.568 19.3515 120.364 19.3515ZM112.332 16.2325H121.231C123.302 16.2325 124.824 16.65 125.795 17.4849C126.751 18.3439 127.228 19.6686 127.228 21.4589C127.228 22.7595 126.931 23.8353 126.337 24.6863C125.751 25.5453 124.888 26.0992 123.748 26.3481L128.035 33.5977H123.965L120.195 26.7937H115.932V33.5977H112.332V16.2325ZM137.368 19.2672C136.091 19.2672 135.108 19.5963 134.418 20.2547C134.072 20.5999 133.799 21.0173 133.599 21.5071C133.406 22.0209 133.31 22.615 133.31 23.2893L143.317 23.3134V26.324H133.286C133.286 27.8333 133.599 28.9172 134.225 29.5755C134.859 30.2338 135.907 30.563 137.368 30.563H143.317V33.5977H137.199C135.818 33.5977 134.759 33.4812 134.02 33.2484C133.265 33.0317 132.543 32.6383 131.852 32.0683C130.977 31.3778 130.319 30.4546 129.878 29.2985C129.436 28.1665 129.215 26.8097 129.215 25.2282C129.215 22.1774 129.87 19.9094 131.178 18.4242C132.495 16.9631 134.534 16.2325 137.296 16.2325H143.317V19.2672H137.368Z" fill="white" />
            <path d="M111.907 4.99633L110.65 8.35542H113.225L111.907 4.99633ZM111.008 3.24085H112.952L116.645 12H114.616L113.821 9.92259H110.055L109.283 12H107.351L111.008 3.24085ZM121.298 10.6333V6.95833H120.278C119.597 6.95833 119.117 7.10006 118.838 7.38353C118.555 7.6751 118.413 8.16104 118.413 8.84136C118.413 9.47714 118.542 9.93676 118.802 10.2202C119.073 10.4956 119.524 10.6333 120.156 10.6333H121.298ZM122.962 12H119.743C118.771 12 118.012 11.7084 117.465 11.1253C116.918 10.5543 116.645 9.74643 116.645 8.70165C116.645 8.25215 116.704 7.86745 116.821 7.54753C116.931 7.19118 117.105 6.86316 117.344 6.5635C117.619 6.21524 117.951 5.96214 118.34 5.80421C118.721 5.65438 119.227 5.57946 119.858 5.57946H121.298V3.24085H122.962V12ZM124.445 5.57946H130.889C131.809 5.57946 132.481 5.76169 132.906 6.12615C133.327 6.4987 133.538 7.10006 133.538 7.93022V12H131.849V8.14282C131.849 7.68522 131.778 7.3734 131.637 7.20737C131.471 7.05754 131.175 6.98262 130.75 6.98262H129.814V12H128.101V6.98262H126.133V12H124.445V5.57946ZM136.8 4.85054H135.038V3.24085H136.8V4.85054ZM136.8 12H135.038V5.57946H136.8V12ZM138.258 5.57946H141.416C142.372 5.57946 143.056 5.76169 143.469 6.12615C143.874 6.49061 144.077 7.09196 144.077 7.93022V12H142.4V8.12459C142.4 7.65485 142.325 7.34506 142.175 7.19522C142.018 7.05349 141.724 6.98262 141.295 6.98262H139.934V12H138.258V5.57946Z" fill="white" />
          </svg>
        </a>

        <a
          href="#"
          className="show-nav-btn"
          data-action="toggle"
          data-class="nav-function-hidden"
          title="Toggle Navigation"
        >
          <LeftOutlined />
        </a>
      </div>
      <nav
        id="js-primary-nav"
        className="primary-nav js-list-filter"
        role="navigation"
      >
        <div className="info-card">
          <img
            src={require("../../../../resources/images/user/user.png")}
            className="profile-image rounded-circle"
            alt={props.userApp &&
              props.userApp.currentUser &&
              props.userApp.currentUser.name}
          />
          <div className="info-card-text">
            <a href="#" className="d-flex align-items-center text-white">
              <span className="text-truncate text-truncate-sm d-inline-block">
                {props.userApp &&
                  props.userApp.currentUser &&
                  props.userApp.currentUser.name}
              </span>
            </a>
            {/* {props.auth && props.auth.email && (
              <span className="d-inline-block text-truncate text-truncate-sm">
                {props.auth && props.auth.email}
              </span>
            )} */}
          </div>
          <img
            src={require("./bg.jpeg")}
            className="cover"
            alt="cover"
            style={{ maxWidth: "100%" }}
          />
          <a
            href="#"
            onClick={() => {
              return false;
            }}
            className="pull-trigger-btn"
            data-action="toggle"
            data-class="list-filter-active"
            data-target=".page-sidebar"
            data-focus="nav_filter_input"
          >
            <i className="fal fa-angle-down"></i>
          </a>
        </div>
        <ul id="js-nav-menu" className="nav-menu">
          {state.menus?.map((item, index) => {
            return (
              <ItemMenu
                key={index}
                index={index}
                item={item}
                toggle={toggle}
                // auth={props.auth}
                isActive={active === index}
                setActive={handleSetActive(index)}
              />
            );
          })}
        </ul>
        <div className="filter-message js-filter-message bg-success-600"></div>
      </nav>
      <div className="nav-footer">
        <Profile handleChangePass={handleChangePass} />
      </div>
    </aside>
  );
};
function mapStateToProps(state) {
  return {
    userApp: state.userApp,
  };
}
export default connect(mapStateToProps)(SideBar);
